import { Value as StateValue } from 'client/app/apps/disco-prototype/state/table';
import { Value } from 'common/types/disco/value';

export const convertValue = (value: StateValue): Value => {
  switch (value.selectedMode) {
    case 'const':
      return {
        type: 'const',
        value: value.value ?? '',
      };
    case 'column':
      return {
        type: 'column',
        name: value.selectedColumnName ?? '',
      };
    default: {
      const _: never = value.selectedMode;
      throw `unexpected value ${_}`;
    }
  }
};
